/* What changed — one line per release, newest first. The app shows the newest
   entry once, on the first sign-in after it ships (web/src/app.tsx →
   WhatsNew). Keep each line in the owner's words: what they can do now, not
   what we refactored. `id` must be unique and only ever grow. */
export type ChangeEntry = { id: string; date: string; title: string; detail: string; route?: string };

export const CHANGELOG: ChangeEntry[] = [
  {
    id: "2026-09-19-roi",
    date: "2026-09-19",
    title: "See what Fence Works did for you",
    detail: "The dashboard now shows the work it brought in and closed, money collected online, calls answered and reviews collected. To-Do lists every automation running for you and what it does next.",
    route: "dashboard",
  },
  {
    id: "2026-09-19-phone",
    date: "2026-09-19",
    title: "Built for the truck",
    detail: "The estimator draws on a full-screen map with the panel as a slide-up sheet. Customers and Messages open one record at a time. Crew Mode routes every stop and installs to your home screen.",
    route: "estimator",
  },
];
